import { useCallback, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";

import { View } from "@com.mgmtp.a12.client/client-core/lib/core/view";
import { DefaultWidgetMap, WidgetMap } from "@com.mgmtp.a12.treeengine/treeengine-core/lib/core/view";
import { TreeEngineFactories } from "@com.mgmtp.a12.treeengine/treeengine-core/lib/extensions/client";
import { Checkbox } from "@com.mgmtp.a12.widgets/widgets-core/lib/input/checkbox";
import { ModalNotification } from "@com.mgmtp.a12.widgets/widgets-core/lib/modal-notification/main/modal-notification.view";
import { ActivityActions, ActivitySelectors } from "@com.mgmtp.a12.client/client-core/lib/core/activity";
import { ButtonGroup } from "@com.mgmtp.a12.widgets/widgets-core/lib/button-group/main/button-group.view";
import { Button } from "@com.mgmtp.a12.widgets/widgets-core/lib/button/main/button.view";

import { getViewHtmlId } from "../../focusHandling/sagas";
import { confirmTextTree } from "../../processFormEngine/sagas/actions";
import { setFilterByKategorie } from "../../../app/slices/textbausteine/reducers";
import { getFilterByKategorie } from "../../../app/slices/textbausteine/selectors";
import { ActivityIdContext } from "../../../component/ActivityContext";
import { CustomProgressIndicator } from "../../../component/CustomProgressIndicator";

export const CustomTextbausteineTreeEngine: View.ViewComponent = function CustomTextbausteineTreeEngine(props) {
	const activityId = props.activityId;
	const activity = useSelector(ActivitySelectors.activityById(activityId));
	const isBusy = activity?.dataHolders?.some(dataHolder => dataHolder.busy);
	const dispatch = useDispatch();
	const filterByKategorie = useSelector(getFilterByKategorie(activityId));

	const onCheckboxClick = useCallback(
		(value: boolean) => {
			dispatch(setFilterByKategorie({ activityId, showAllKategorie: value }));
		},
		[dispatch, activityId]
	);

	const onAbbrechenClick = useCallback(() => {
		dispatch(ActivityActions.cancel({ activityId }));
	}, [dispatch, activityId]);

	const onConfirmClick = useCallback(() => {
		dispatch(confirmTextTree({ activityId }));
	}, [dispatch, activityId]);

	const widgetMap: WidgetMap = useMemo(
		() => ({
			...DefaultWidgetMap,
			Button: props => {
				return <DefaultWidgetMap.Button {...props} disabled={false} />;
			}
		}),
		[]
	);

	return (
		<ModalNotification
			id={getViewHtmlId(activityId)}
			title={"Textbausteine auswählen"}
			enableCloseButton={true}
			icon={" "}
			variant="info"
			closeOnOutsideClick={true}
			closeOnEsc={true}
			onClose={onAbbrechenClick}
			footer={
				<ButtonGroup alignment="right">
					<Button label={"Abbrechen"} secondary onClick={onAbbrechenClick} />
					<Button label={"Textbausteine verwenden"} primary onClick={onConfirmClick} disabled={isBusy} />
				</ButtonGroup>
			}
		>
			<ActivityIdContext value={props.activityId}>
				<CustomProgressIndicator hide={!isBusy}>
					<Checkbox
						label={"Alle Textbausteine anzeigen"}
						onChange={onCheckboxClick}
						checked={filterByKategorie}
					/>
					<TreeEngineFactories.ViewComponent {...props} widgetMap={widgetMap} />
				</CustomProgressIndicator>
			</ActivityIdContext>
		</ModalNotification>
	);
};
